import { useEffect, useState } from "react";
import { get } from "../api";

/**
 * The small numbers on the "Venner" menu item (new requests + invitations). The same call is the sign of life that shows the player as "online"
 * to the friends – it runs every 45 s while the tab is visible (and at once when the tab comes back).
 */
export interface FriendSummary { incoming: number; invites: number; friends: number; online: number }
const EMPTY: FriendSummary = { incoming: 0, invites: 0, friends: 0, online: 0 };
let current: FriendSummary = EMPTY;
const listeners = new Set<(s: FriendSummary) => void>();
let timer: ReturnType<typeof setInterval> | null = null;

export async function refreshFriendSummary(): Promise<void> {
  try {
    current = await get<FriendSummary>("/api/friends/summary");
    for (const l of listeners) l(current);
  } catch {
    /* offline or signed out – the badge simply stays as it was */
  }
}
function start() {
  if (timer) return;
  void refreshFriendSummary();
  timer = setInterval(() => { if (typeof document === "undefined" || !document.hidden) void refreshFriendSummary(); }, 45_000);
  if (typeof document !== "undefined") document.addEventListener("visibilitychange", onVisible);
}
function onVisible() { if (!document.hidden) void refreshFriendSummary(); }
function stop() {
  if (timer) clearInterval(timer);
  timer = null;
  if (typeof document !== "undefined") document.removeEventListener("visibilitychange", onVisible);
  current = EMPTY;
}

export function useFriendSummary(active: boolean): FriendSummary {
  const [s, setS] = useState<FriendSummary>(current);
  useEffect(() => {
    if (!active) return;
    listeners.add(setS);
    start();
    return () => {
      listeners.delete(setS);
      if (!listeners.size) stop();
    };
  }, [active]);
  return active ? s : EMPTY;
}
